import React, { useContext, useEffect, useMemo, useState } from 'react'
import CourseQuiz from '../course-quiz/CourseQuiz';
import CourseResult from '../course-result/CourseResult';
import authContext from 'shared/src/contexts/authContext';
import { getToken } from 'shared/src/services/user-info.service';
import { getFinalScoreOncredit, saveFinalScoreOncredit } from 'services/routeServices';

import "./evaluationCredits.scss"
import Loader from 'shared/src/components/atoms/loader/loader';


interface EvaluationCreditsProps {
  setShowEvaluation: React.Dispatch<React.SetStateAction<boolean>>;
  evaluationBlocked: boolean;
  showEvaluation: boolean;
  setResponseModalAction: React.Dispatch<React.SetStateAction<string | undefined>>;
  setResponseModalValue: React.Dispatch<React.SetStateAction<boolean | undefined>>;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const EvaluationCredits: React.FC<EvaluationCreditsProps> = ({ setShowEvaluation, evaluationBlocked, setResponseModalValue, setResponseModalAction,  setShowModal }) => {

  const [resultQuiz, setResultQuiz] = useState<any[]>([]);
  const [buttonEvent, setButtonEvent] = useState<boolean>(false);
  const [isFinished, setIsFinished] = useState<boolean>(false);
  const [isResetQuiz, setIsResetQuiz] = useState<boolean>(false);
  const [score, setScore] = useState<number>(0)
  const [isLoding, setIsLoding] = useState<boolean>(true)
  const auth = useContext(authContext);

  const getPunctuationData = async () => {
    try {
      const score = (await getFinalScoreOncredit()).data.data;
      if (score != -1) {
        setIsFinished(true)
      }
      setScore(score);

    } catch (error) {
      console.error("Error al obtener las preguntas del curso.");
    }
  }

  const savePunctuation = async (score: number) => {
    try {
      const response = await saveFinalScoreOncredit(score);
    } catch (error) {
      console.error("Error al obtener las preguntas del curso.");
    }
  }

  useMemo(() => {

    if (isFinished) {

      if (resultQuiz.length > 0) {
        const questionCorrects = resultQuiz.filter(element => element.optionSelected.correctOption).length;
        const score = (questionCorrects * (100 / 6)).toFixed(0);
        savePunctuation(parseInt(score))
        setScore(parseInt(score))
      }

    }

  }, [isFinished]);

  useEffect(() => {
    setIsLoding(false)
  }, [score])

  useEffect(() => {
    getPunctuationData()
    setIsLoding(true)
  }, [])


  return (
    <>
      {
        isLoding ? <div className='containerLoader'>
          <Loader />
        </div> :
          isFinished == false ? <CourseQuiz
            resultQuiz={resultQuiz}
            buttonEvent={buttonEvent}
            isFinished={isFinished}
            isResetQuiz={isResetQuiz}
            evaluationBlocked={evaluationBlocked}
            setResponseModalValue={setResponseModalValue}
            setResponseModalAction={setResponseModalAction}
            setResultQuiz={setResultQuiz}
            setButtonEvent={setButtonEvent}
            setIsFinished={setIsFinished}
            setIsResetQuiz={setIsResetQuiz}
            setShowEvaluation={setShowEvaluation}
            setShowModal={setShowModal}
          /> : <CourseResult
            punctuation={score}
            setIsResetQuiz={setIsResetQuiz}
            setIsFinished={setIsFinished}
          />
      }
    </>
  )
}

export default EvaluationCredits
